<template>
    <div class="page">
      <Header :title="titleText" :leftHandler="back" />
      <van-field v-model="form.contactPerson" label="收货人" placeholder="请输入收货人姓名" />
      <van-field v-model="form.contactMobile" label="联系电话" placeholder="请输入联系电话" />
      <van-cell title="所在地区" :value="location" is-link @click="popupShow = true"></van-cell>
      <van-field v-model="form.detailAddress" rows="4" type="textarea" placeholder="请填写详细地址"  maxlength="50"  show-word-limit />
      <van-cell title="设为默认">
        <template #right-icon>
          <van-checkbox checked-color="#00545e" v-model="form.isDefault">
          </van-checkbox>
        </template>
      </van-cell>
      <van-field v-model="form.getCode" center clearable label="验证码" placeholder="请输入短信验证码">
        <template #button>
          <van-button size="small" type="primary" @click="getCode" v-if="!isGeting">获取验证码</van-button>
          <van-button size="small" type="primary" v-if="isGeting">{{ countdown }}s</van-button>
        </template>
      </van-field>
      <div class="text-center">
        <van-button type="primary" class="center-personal-data-submit" @click="apply">提交申请</van-button>
      </div>
      <van-popup v-model="popupShow" round position="bottom">
        <van-cascader v-model="form.countyId" title="请选择所在地区" :options="options" @finish="finish"
          :field-names="fieldNames" @close="close()" />
      </van-popup>
    </div>
  </template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import baseApi from '@/api/base'
import { mapState } from 'vuex'
export default {
  components: {
    Header
  },
  data () {
    return {
      address: {},
      titleText: '新增地址',
      form: {
        addressId: '',
        contactPerson: '',
        contactMobile: '',
        cityId: '',
        countyId: '',
        provinceId: '',
        isDefault: '',
        zipCode: '',
        detailAddress: '',
        getCode: ''
      },
      isGeting: false,
      countdown: 60,
      popupShow: false,
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'child'
      },
      options: [],
      location: '',
      selectCouponId: 0,
      selectAddress: '',
      itemId: ''
    }
  },
  created () {
    this.selectCouponId = this.$route.params.couponId || 0
    this.selectAddress = this.$route.params.selectAddress
    this.itemId = this.$route.params.itemId
    if (this.userRole === '03') {
      this.$toast('没有修改收货地址的权限')
    } else {
      this.init()
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  methods: {
    init () {
      this.addressId = this.$route.params.addressId || ''
      this.itemId = this.$route.params.itemId
      if (this.$route.params.addressId) {
        this.titleText = '修改地址'
        for (const key in this.form) {
          this.form[key] = this.$route.params[key]
        }
      } else {
        this.titleText = '新增地址'
      }
      this.getDistrictList()
    },
    getDistrictList () {
      baseApi.getDistrictList().then(res => {
        if (res.data.resultCode === '0') {
          this.options = res.data.resultData.data
          if (this.addressId && this.options && this.options.length) {
            let province = this.options.find(item => {
              return item.id === this.form.provinceId
            })
            let city = province.child.find(item => {
              return item.id === this.form.cityId
            })
            let county = city.child.find(item => {
              return item.id === this.form.countyId
            })
            this.location = province.name + city.name + county.name
          }
        }
      })
    },
    finish (value) {
      this.form.provinceId = value.selectedOptions[0].id
      this.form.cityId = value.selectedOptions[1].id
      this.form.countyId = value.selectedOptions[2].id
      this.location = value.selectedOptions[0].name + value.selectedOptions[1].name + value.selectedOptions[2].name
      this.popupShow = false
    },
    // 提交
    apply () {
      if (!this.checkApplyData()) return
      const data = {
        addressInfo: {
          provinceId: this.form.provinceId,
          itemId: this.itemId,
          cityId: this.form.cityId,
          countyId: this.form.countyId,
          detailAddress: this.form.detailAddress,
          isDefault: this.form.isDefault ? 1 : 0,
          contactPerson: this.form.contactPerson,
          contactMobile: this.form.contactMobile,
          contactPhone: '',
          contactEmail: '',
          zipCode: ''
        },
        verifyCode: this.form.getCode
      }
      if (this.$route.params.addressId) {
        // 修改
        data.addressInfo.addressId = this.addressId
        data.addressInfo.itemId = this.itemId
        activityApi.updateAddress(data).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('修改成功')
            this.$router.push({
              name: 'spikeAddress',
              params: {
                selectAddress: this.$route.params.selectAddress,
                selectCouponId: this.$route.params.couponId,
                itemId: this.$route.params.itemId
              }
            })
          }
        })
      } else {
        // 新增
        activityApi.createAddress(data).then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('新增地址成功')
            // this.$router.go(-1)
            this.$router.push({
              name: 'spikeAddress',
              params: {
                selectAddress: this.$route.params.selectAddress,
                selectCouponId: this.$route.params.couponId,
                itemId: this.$route.params.itemId
              }
            })
          }
        })
      }
    },
    // 获取验证码
    getCode () {
      if (!this.isGeting) {
        let that = this
        activityApi.getAddressVerifyCode().then(res => {
          if (res.data.resultCode === '0') {
            this.$toast('验证码已发送，请注意查收')
            this.isGeting = true
            var timer = setInterval(function () {
              if (that.countdown > 0) {
                that.countdown--
              } else {
                clearInterval(timer)
                that.isGeting = false
                that.countdown = 60
              }
            }, 1000)
          }
        })
      }
    },
    checkApplyData () {
      if (!this.form.contactPerson) {
        this.$toast('请填写收货人')
        return false
      }
      if (!this.form.contactMobile) {
        this.$toast('请填写联系电话')
        return false
      }
      if (!this.location) {
        this.$toast('请填写所在地区')
        return false
      }
      if (!this.form.detailAddress) {
        this.$toast('请填写详细地址')
        return false
      }
      if (!this.form.getCode) {
        this.$toast('请填写验证码')
        return false
      }
      return true
    },
    back () {
      this.$router.push({
        name: 'spikeAddress',
        params: {
          selectAddress: this.$route.params.selectAddress,
          selectCouponId: this.$route.params.couponId,
          itemId: this.$route.params.itemId
        }
      })
    },
    close () {
      this.popupShow = false
    }
  }
}
</script>
  <style scoped lang="less">
  .center-personal-data-submit {
    width: 80%;
    margin: 0.5rem auto 0 auto
  }

  .van-cascader /deep/ .van-tabs__content {
    min-height: auto;
  }
  </style>
